export const HOMEOWNER_INFO_MAP = {
  homeownerFormRadioButtons: [
    {
      unique_name: 'the_only_homeowner',
      title: 'I am the only homeowner.',
    },
    {
      unique_name: 'multiple_homeowners',
      title: 'There are multiple homeowners.',
    },
  ],
  addressFormRadioButtons: [
    {
      unique_name: '876090000',
      title: 'My primary residence',
    },
    {
      unique_name: '876090001',
      title: 'Rental property',
    },
    {
      unique_name: '876090002',
      title: 'Rehab property',
    },
    {
      unique_name: '876090003',
      title: 'Investment property',
    },
  ],
};
